import React, { FC } from 'react';
import ModalComponentsWrapper from '../../shared/modal/modal';
import { ModalTypes } from '../../../constans/modal.constants';
import { useStore } from '../../../store/store-provider';
import { observer } from 'mobx-react';
import { AttendeeConnectionVariant } from '../../../constans/attendee-enums';

const ChangeConnectionStatusConfirmationModalComponent: FC = () => {
  const { attendeesStore } = useStore();
  const { getAttendeeConnectionControlService } = attendeesStore;
  const {
    shouldShowConfirmationModal,
    closeConfirmationModal,
    selectedAttendeeViewerId,
    confirmAttendeeStatusChange,
    modalVariant
  } = getAttendeeConnectionControlService();

  const htmlString = modalVariant === AttendeeConnectionVariant.DISCONNECT
    ? `Are you sure you want to disconnect</br><b>${selectedAttendeeViewerId}</b> from this session?`
    : `Are you sure you want to reconnect</br><b>${selectedAttendeeViewerId}</b> to this session?`;

  const doneButtonText = modalVariant === AttendeeConnectionVariant.DISCONNECT
    ? 'Yes, disconnect attendee'
    : 'Yes, reconnect attendee';

  return shouldShowConfirmationModal
    ? (
      <ModalComponentsWrapper
        additionalClassNames="change-connection-status-confirmation-modal"
        cancelAction={closeConfirmationModal}
        modalType={ModalTypes.CONFIRMATION}
        htmlString={htmlString}
        doneButtonText={doneButtonText}
        doneAction={confirmAttendeeStatusChange}
      />
    )
    : null;
};

const ChangeConnectionStatusConfirmationModal = observer(ChangeConnectionStatusConfirmationModalComponent);

export { ChangeConnectionStatusConfirmationModal };
